<template>
    <div v-show="visible">
        <el-dialog title="家属详情" :visible.sync="visible" v-loading="loading" :close-on-click-modal="false" :before-close="dialogClose"  width="650px"> 
            <div style="">
                <div style=" margin-bottom:10px;font-weight:bold;">基本信息：</div>
                <table style="width: 100%; font-weight: 300;font-size: 14px;">
                    <tr>
                        <td width="155px" style="background-color: #F6F7FB;">
                            称呼：
                        </td>
                        <td class="pricrTd" width="200px">{{this.form.title?this.form.title:"无"}}</td>
                         <td width="155px" style="background-color: #F6F7FB;">
                            身份证：
                        </td>
                        <td class="pricrTd" width="280px">{{this.form.identityCard?this.form.identityCard:"无"}}</td>
                        <td width="155px" rowspan="3">
                            <el-upload 
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :disabled="isUploadImage"
                                :show-file-list="false"
                                :auto-upload="true"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">
                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <span style="font-size:12px;color:red">(温馨提示：如果遇到照片倒向，请另存图片到本地，再通过本地旋转正常再进行上传。)</span>
                        </td>
                    </tr>
                </table>
            </div>
 
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="visible=false">关 闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                form:{
                    id:"",
                    title:"",
                    identityCard:"",
                    userId:""
                },
                uploadForm:new FormData(),
                imageUrl: "",
                uploadUrl:"",
                isUploadImage:false
            }
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // console.log("详情："+JSON.stringify(data));
                this.form.id=data.id;
                this.form.title=data.title;
                this.form.identityCard=data.identityCard;
                this.form.faceImage=data.faceImage;
                this.form.userId=data.userId;
                // console.log("用户ID："+data.userId);
                // 初始地址
                this.uploadForm=new FormData(); 
                this.uploadUrl=this.nameUploadImageUrl;
                this.imageUrl=data.faceImage;
                // 是否二级平台，如果是二级平台上传图片不能用
                let platform =JSON.parse(sessionStorage.getItem('platforminfo')).platform;
                if(platform == 'twoPlatform'){
                    this.isUploadImage=false;
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                let isJPG = (file.type == 'image/jpeg' || file.type == 'image/png');
                let isLt2M = file.size / 1024 / 1024 < 8;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 8MB!');
                }
                if(isJPG && isLt2M){
                    this.uploadForm=new FormData(); 
                    // 上传文件
                    this.uploadForm.append('file', file);
                    this.$axios.post(this.nameUploadImageUrl, this.uploadForm).then((res) => {
                        if(res.data.status == 200){
                           // console.log("临时文件目录："+res.data.data.localFile);
                           this.form.faceImage=res.data.data.localFile;
                           // 提交图片都后台，并验证该图片是否正常
                           this.loading=true;
                           let url = this.familyUpdateUrl;
                           let data = {
                                id:this.form.id,
                                faceImage:this.form.faceImage,
                           }; 
                           // console.log("提交列表:"+JSON.stringify(data))
                           this.apiPost(url, data).then((res) => {
                                // console.log("响应列表:"+JSON.stringify(res))
                                if(res.status == 200){
                                    this.$commonFn.showTip(res.message,1);
                                    this.$parent.getData(this.form.userId);
                                }else{
                                    this.$commonFn.showTip(res.message, 3);
                                }
                                this.loading=false;
                            }, (err) => {
                                console.log(JSON.stringify(err));
                                this.$commonFn.showTip(err.message, 3);
                                this.loading=false;
                            });
                        }else{
                            this.$commonFn.showTip(res.data.message, 3);
                        }
                    }, (err) => {
                        console.log(err)
                        this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3);
                    });
                }else{
                    return false;
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     table{
        border: 0px solid rgb(216,220,228);
        border-collapse: collapse;
    }

    td{
        font-weight: 400;
        text-align: right;
        border: 0px solid rgb(216,220,228);
        height:38px;
    }

    .pricrTd{
        font-weight: 400 !important;
        text-align: left !important;
        padding-left: 10px;
    }
    .avatar {
        width: 130px;
        height: 108px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/sys/user/FamilyDetails.vue